import React from 'react';
export function Footer() {
  return <footer className="bg-white border-t border-slate-100 py-12" data-id="element-31">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-32">
        <div className="text-center md:text-left" data-id="element-33">
          <div className="flex items-center justify-center md:justify-start gap-2" data-id="element-34">
            <img src="https://cdn.magicpatterns.com/uploads/pKnV3JbaQe8rMACB2pGNu8/pasted-image.png" alt="GO OUT Performance" className="h-8 w-auto" data-id="element-35" />
            <span className="text-xl font-bold text-navy-900" data-id="element-36">
              GO OUT <span className="text-blue-600" data-id="element-37">Performance</span>
            </span>
          </div>
          <p className="text-slate-500 text-sm mt-2" data-id="element-38">
            Publicidad digital estratégica para empresas en Costa Rica.
          </p>
        </div>

        <div className="flex space-x-6" data-id="element-39">
          <a href="#" className="text-slate-500 hover:text-blue-600 transition-colors text-sm" data-id="element-40">
            LinkedIn
          </a>
          <a href="#" className="text-slate-500 hover:text-blue-600 transition-colors text-sm" data-id="element-41">
            Email
          </a>
        </div>

        <div className="text-slate-400 text-sm" data-id="element-42">
          © {new Date().getFullYear()} Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}